// extracted by mini-css-extract-plugin
module.exports = {"section":"_33mPE","list":"_1-Phk","listItem":"_1_BJ2","link":"_2U5II","active":"K-uqr"};